import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { SocialUrl } from './socialUrl'
import { ComponentWillMountSymbol } from 'feature-components'

export const page: ContainerModuleLoader = (bind) => {
	bind(ComponentWillMountSymbol).to(SocialUrl)
}
